import { render, staticRenderFns } from "./SidebarFileList.vue?vue&type=template&id=9fe74d26"
import script from "./SidebarFileList.vue?vue&type=script&lang=ts"
export * from "./SidebarFileList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports